import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <path
    d="M16.5501 21.952C16.2971 21.952 16.0441 21.856 15.8511 21.665L6.75011 12.686C6.56111 12.498 6.45311 12.243 6.45411 11.976C6.45411 11.709 6.56111 11.455 6.75211 11.267L15.8531 2.334C16.2441 1.948 16.8731 1.955 17.2601 2.347C17.6451 2.739 17.6391 3.369 17.2461 3.754L8.86911 11.979L17.2491 20.248C17.6411 20.634 17.6441 21.264 17.2591 21.655C17.0641 21.852 16.8061 21.952 16.5491 21.952H16.5501Z"
    fill="currentColor"
  />
);

const Icon = createSvgIcon(svg, 'ChevronLeft');

export default Icon;
